import React, { useState } from 'react';
import { Styles } from '../../../../../config/design/styles';
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { withStyles } from "@mui/styles";
import {DragIndicatorRounded} from "@mui/icons-material";
import Button from "@mui/material/Button";
import CategoriesOrder from "./CategoriesOrder";
import {useTranslation} from "react-i18next";

const CategoriesOrderButton = (props) => {
    const { classes, reload } = props;
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const handleClose = () => {
        setOpen(false);
        reload();
    };

    return (
        <>
            <Button
                color="secondary"
                onClick={() => setOpen(true)}
                startIcon={<DragIndicatorRounded/>}
            >
                {t('manageCategoriesOrder')}
            </Button>

            <Dialog
                maxWidth="sm"
                fullWidth
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle id="customized-dialog-title">
                    {t('manageCategoriesOrder')}
                    <IconButton
                        onClick={handleClose}
                        className={classes.modalCloseButton}
                        size="small"
                    >
                        <CloseRoundedIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <CategoriesOrder industry_id={props.industry_id}/>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default withStyles(Styles)(CategoriesOrderButton);
